/**
 * PDP reviews: enlarge media UX, lightbox, auto "Load more",
 * and Add Your Review → Judge.me / Loox write form when present.
 */
(function () {
  var root = null;
  var lightbox = null;
  var lightboxImg = null;

  function getRoot() {
    return (
      document.getElementById('ProductReviews') ||
      document.querySelector('.fp-product-reviews') ||
      document.querySelector('.fp-amazon-reviews')
    );
  }

  function ensureLightbox() {
    if (lightbox) return;
    lightbox = document.createElement('div');
    lightbox.className = 'fp-rev-lightbox';
    lightbox.setAttribute('role', 'dialog');
    lightbox.setAttribute('aria-modal', 'true');
    lightbox.innerHTML =
      '<button type="button" class="fp-rev-lightbox__close" aria-label="Close">&times;</button>' +
      '<img class="fp-rev-lightbox__img" alt="">';
    document.body.appendChild(lightbox);
    lightboxImg = lightbox.querySelector('.fp-rev-lightbox__img');

    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox || e.target.classList.contains('fp-rev-lightbox__close')) {
        closeLightbox();
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeLightbox();
    });
  }

  function openLightbox(src, alt) {
    if (!src) return;
    ensureLightbox();
    lightboxImg.src = src;
    lightboxImg.alt = alt || 'Review photo';
    lightbox.classList.add('is-open');
    document.body.classList.add('fp-rev-lightbox-open');
  }

  function closeLightbox() {
    if (!lightbox) return;
    lightbox.classList.remove('is-open');
    document.body.classList.remove('fp-rev-lightbox-open');
    lightboxImg.removeAttribute('src');
  }

  function isReviewImage(img) {
    if (!img || img.tagName !== 'IMG') return false;
    if (img.closest('.fp-rev-lightbox, .fp-sr-viewer, .fp-sr__card')) return false;
    if (img.width > 0 && img.width < 28 && img.height > 0 && img.height < 28) return false;
    var cls = (img.className || '') + ' ' + ((img.parentElement && img.parentElement.className) || '');
    var src = img.currentSrc || img.src || '';
    if (/star|icon|logo|avatar|badge|emoji|sprite/i.test(cls + ' ' + src)) return false;
    if (img.closest('[class*="reputon"], .jdgm-widget, .loox-reviews, [class*="review"]')) return true;
    return /review|media|cdn\.shopify|cloudinary|loox|jdgm|reputon/i.test(src);
  }

  function bindLightboxClicks() {
    root = getRoot();
    if (!root) return;
    root.addEventListener(
      'click',
      function (e) {
        var img = e.target.closest('img');
        if (!img || !root.contains(img) || !isReviewImage(img)) return;
        e.preventDefault();
        e.stopPropagation();
        var full =
          img.getAttribute('data-full') ||
          img.getAttribute('data-src') ||
          img.currentSrc ||
          img.src;
        openLightbox(full, img.alt);
      },
      true
    );
  }

  function clickLoadMore(scope) {
    if (!scope) return false;
    var candidates = scope.querySelectorAll(
      'button, a, [role="button"], [class*="load"], [class*="Load"], [class*="more"], [class*="More"]'
    );
    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      if (el.disabled || el.getAttribute('aria-disabled') === 'true') continue;
      if (el.offsetParent === null && getComputedStyle(el).display === 'none') continue;
      var text = (el.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (!text) continue;
      if (
        text === 'load more' ||
        text === 'show more' ||
        text === 'see more' ||
        text.indexOf('load more') !== -1 ||
        text.indexOf('show more reviews') !== -1
      ) {
        el.click();
        return true;
      }
    }
    return false;
  }

  function autoExpandReviews() {
    root = getRoot();
    if (!root) return;
    var tries = 0;
    var maxTries = 12;
    function tick() {
      tries += 1;
      var clicked = clickLoadMore(root);
      if (clicked && tries < maxTries) {
        setTimeout(tick, 700);
      }
    }
    setTimeout(tick, 900);
  }

  function openWriteForm(e) {
    if (e) e.preventDefault();
    root = getRoot();

    var jdgmWrite =
      document.querySelector('.jdgm-write-rev-link') ||
      document.querySelector('[data-jdgm-write-review]') ||
      document.querySelector('a[href*="write-review"]');
    if (jdgmWrite) {
      jdgmWrite.click();
      return;
    }

    var looxWrite =
      document.querySelector('.loox-write-review') ||
      document.querySelector('[data-loox-write-review]') ||
      document.querySelector('#looxReviews a[href*="write"]');
    if (looxWrite) {
      looxWrite.click();
      return;
    }

    var target =
      document.getElementById('ProductReviewsWrite') ||
      document.getElementById('judgeme_product_reviews') ||
      document.getElementById('ProductReviewsList') ||
      root;
    if (target) {
      if (history.replaceState) history.replaceState(null, '', '#ProductReviewsWrite');
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  function bindWriteLinks() {
    document.addEventListener(
      'click',
      function (e) {
        var link = e.target.closest(
          'a[href="#ProductReviewsWrite"], a[href$="#ProductReviewsWrite"], [data-fp-write-review]'
        );
        if (!link) return;
        openWriteForm(e);
      },
      true
    );
  }

  function boot() {
    root = getRoot();
    if (!root) return;
    bindLightboxClicks();
    bindWriteLinks();
    autoExpandReviews();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('load', function () {
    setTimeout(autoExpandReviews, 500);
  });
})();
